import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Adimplencia extends Service {
  constructor() {
    super()
    this._adimplenciaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Adimplencia`
    )

    this._serviceEmpresa = new Empresa()
  }

  async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando faixa de Adimplência')
      let doc = await this._adimplenciaRef.doc(`${values.apelido}`+`${values.papel.toUpperCase()}`)
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(adimplenciaId, values) {
    try {
      this._loading.setLoading(true, 'Atualizando faixa de Adimplência')
      delete values.id
      const adimplencia = await this._adimplenciaRef.doc(adimplenciaId)
      adimplencia.update({
        ...values
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  
  async delete(adimplenciaId) {
    try {
      this._loading.setLoading(true, 'Deletando faixa de Adimplência')
      const adimplencia = await this._adimplenciaRef.doc(adimplenciaId)
      adimplencia.delete()

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }



  async getByEmpresaPapel(items, dat) {
    let adimplencia = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de adimplência')
      for (let item of items.empresas) {
        const empresa = dat.find(element => element.cnpj === item);

        const response = await this._adimplenciaRef
          .where("empresa", "==", empresa.cnpj)
          .where("papel", "==", items.papel)
          .get();

        if (!response.empty) {
          for (let doc of response.docs) {
            let faixa = doc.data();

            adimplencia.push({
              id: doc.id,
              nomeEmpresa: empresa.nome,
              ...faixa
            });
          }
        }
      }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async getByCnpjPapel(cnpj, papel) {
    let adimplencia = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de adimplência')

        const response = await this._adimplenciaRef
          .where("empresa", "==", cnpj)
          .where("papel", "==", papel)
          .get();
          
        if (!response.empty) {
          for (let doc of response.docs) {
            adimplencia.push(doc.data());
          }
        }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }



  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando todas faixas de adimplencia')
      const response = await this._adimplenciaRef.get()

      let adimplencia = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          adimplencia.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(adimplencia)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
